import { defineSlotRecipe } from '@chakra-ui/react';

export const checkboxRecipe = defineSlotRecipe({
	slots: ['root', 'control'],
	base: {
		root: {
			display: 'inline-flex',
			gap: '2',
			alignItems: 'center',
			verticalAlign: 'top',
			position: 'relative',
		},
		control: {
			borderRadius: '6px',
			backgroundColor: 'white',
		},
	},
});
